import React, { useEffect, useMemo, useState } from "react";
import { Base } from "../../framework/base";
import { useFetch } from "../../hooks/useFetch";
import { SalaryRowTypeItem } from "../../models/salary/salaryRowTypeItem";
import { getSalaryRowTypeItems } from "../../services/salaryRowTypeService";
import { MainLayout } from "../layout/mainLayout";
import { WorkTimeFilters } from "../workTimeBeta/workTimeFilters";
import SalariesEvents from "./salariesEvents";
import { SalariesListGrid } from "./salariesListGrid";
import Button from "@mui/material/Button";
import { customHistory } from "../../framework/customHistory";
import { EmployeeListItemDto } from "../../models/employee/employee";
import { useAppSelector } from "../../framework/customStore";
import { getEmployees } from "../../services/employeeServiceNew";
import Grid2 from "@mui/material/Unstable_Grid2";
import { getWorkHourSalaries } from "../../services/workHourSalaryService";
import { SalaryItem } from "../../models/workHourSalary/salaryItem";
import { useTranslation } from "react-i18next";

export const SalariesMain = () => {
    const { t } = useTranslation();
    const [salaryRowTypes, setSalaryRowTypes] = useState<SalaryRowTypeItem[]>();
    const [employees, setEmployees] = useState<EmployeeListItemDto[]>();
    const [transferDialogOpen, setTransferDialogOpen] = useState(false);
    const [salaries, setSalaries] = useState<SalaryItem[]>([]);
    const [loading, setLoading] = useState(false);
    const [dataInitialized, setDataInitialized] = useState(false);
    const fetchFilters = useAppSelector(state => state.workTimeBeta.fetchFilters);
    const filters = useAppSelector(state => state.workTimeBeta.filters);

    const selectedEmployeeGroupId = useAppSelector(
        (state) => state.workTimeBeta.filters.selectedEmployeeGroup?.id
    );

    const displayedSalaries = useMemo(() => {
        return salaries.filter(
            (s) =>
                filters.selectedEmployees.length === 0 ||
                filters.selectedEmployees.includes(s.employeeId)
        );
    }, [salaries, filters.selectedEmployees]);

    const loadSalaries = (signal?: AbortSignal) => {
        if (!fetchFilters.selectedSalaryPeriod || !filters.selectedEmployeeGroup) {
            setSalaries([]);
            return;
        }

        setLoading(true);
        getWorkHourSalaries({
            salaryPeriodId: fetchFilters.selectedSalaryPeriod.id,
            employeeGroupId: filters.selectedEmployeeGroup.id
        }, signal)
            .then((res) => {
                setSalaries(res.data);
                setDataInitialized(true);
            })
            .catch((err) => {
                console.log("error", err);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(loadSalaries, [filters.selectedEmployeeGroup, fetchFilters.selectedSalaryPeriod]);

    useFetch(
        (signal) => {
            if (selectedEmployeeGroupId) {
                return getEmployees(selectedEmployeeGroupId, signal);
            }
        },
        {
            onSuccess: (res) => setEmployees(res.data),
        },
        [selectedEmployeeGroupId]
    );

    useFetch(
        () => getSalaryRowTypeItems(1000, 1, "", "name", true),
        {
            onSuccess: (res) => {
                res.items.sort((a, b) => Base.stringCompare(a.code, b.code));
                setSalaryRowTypes(res.items);
            },
        },
        []
    );

    const onSendToErp = () => {
        setTransferDialogOpen(true);
    };

    const handleSendToErpClose = () => {
        setTransferDialogOpen(false);
    };

    return (
        <MainLayout
            noContainer
            className="fluid"
            topComponent={
                <WorkTimeFilters
                    showSendToErp
                    employees={employees}
                    onSendToErp={onSendToErp}
                    displayedSalaries={displayedSalaries}
                />}
        >
            <Grid2>
                {salaryRowTypes && (
                    <SalariesListGrid
                        salaryRowTypes={salaryRowTypes}
                        salaries={salaries}
                        displayedSalaries={displayedSalaries}
                        transferDialogOpen={transferDialogOpen}
                        fetchFilters={fetchFilters}
                        handleClose={handleSendToErpClose}
                        loading={loading}
                        dataInitialized={dataInitialized}
                    />
                )}
                <SalariesEvents />
                <Button
                    sx={{ marginTop: 2 }}
                    variant="contained"
                    onClick={() =>
                        customHistory.push("/worktimepage/salaries/archive")
                    }
                >
                    {t("workTime.salariesArchive")}
                </Button>
            </Grid2>
        </MainLayout>
    );
};
